import { PriceConfiguration, SubscriptionAddonType, SubscriptionAddons as SubscriptionAddonsBase } from "clearline-api";

export class SubscriptionAddons implements SubscriptionAddonsBase {
  public id: number;
  public name: string;
  public description: string;
  public defaultPriceConfiguration: PriceConfiguration;
  public addonType: SubscriptionAddonType;
  public quantity?: number;
  public imageUrl: string;
  public info: string;
  public isActive: boolean;
}
